import {
  createSlice,
  createSelector,
  type PayloadAction,
} from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import type { NorfolkSouthernTrainSelection } from './types';

export type { NorfolkSouthernTrainSelection } from './types';

interface NorfolkSouthernState {
  preselectedTrain: NorfolkSouthernTrainSelection | null;
}

export const norfolkSouthernInitialState: NorfolkSouthernState = {
  preselectedTrain: null,
};

type StateWithNorfolkSouthern = {
  norfolkSouthern?: Partial<NorfolkSouthernState>;
};

const selectNorfolkSouthernSlice = (state: StateWithNorfolkSouthern) =>
  state.norfolkSouthern;

export const selectPreselectedNorfolkSouthernTrain = createSelector(
  [selectNorfolkSouthernSlice],
  slice => slice?.preselectedTrain ?? null,
);

/**
 * UI state for the Norfolk Southern consist request flow. The request rows
 * themselves are cached by digitalDispatchApi.
 */
const norfolkSouthernSlice = createSlice({
  name: 'norfolkSouthern',
  initialState: norfolkSouthernInitialState,
  reducers: {
    setPreselectedTrain: (
      state,
      action: PayloadAction<NorfolkSouthernTrainSelection | null>,
    ) => {
      state.preselectedTrain = action.payload;
    },
    clearPreselectedTrain: state => {
      state.preselectedTrain = null;
    },
  },
});

export const { setPreselectedTrain, clearPreselectedTrain } =
  norfolkSouthernSlice.actions;

export const usePreselectedNorfolkSouthernTrain = () =>
  useSelector(selectPreselectedNorfolkSouthernTrain);

export default norfolkSouthernSlice.reducer;
